export default {
	treatment: 'Treatment',
	price: 'Price',
	description: 'Description',
	updated_at: 'Updated At',
	new_service: 'New Service',
	update_service: 'Update Service'
};
